// EntityHeader.tsx
import { useTranslation } from "react-i18next";

import CorporationIcon from "src/core/assets/images/icons/entreprise.svg?react";
import PersonIcon from "src/core/assets/images/icons/stakeholders.svg?react";
import { MappedEntity } from "src/core/types/entity";

type EntityDetailHeaderProps = {
  entity: MappedEntity;
};

export const EntityDetailHeader = ({ entity }: EntityDetailHeaderProps) => {
  const { t } = useTranslation();

  if (!entity) return null;

  return (
    <div className="flex items-center h-40 w-full border-t border-b border-border bg-gray-xxlight px-20 font-light">
      {entity.isPPH ? (
        <>
          <PersonIcon />
          <span className="ml-10 w-[160px]">{entity.firstName + " " + entity.lastName}</span>

          {entity.birthDate && (
            <span className="ml-[150px] w-[200px]">
              {t("modal.entityDetails.entity.birthDate") + " " + entity.birthDate}
            </span>
          )}

          {entity.citizenshipCountryCode && (
            <span className="ml-[60px] w-[200px]">
              {t("modal.entityDetails.entity.citizenshipCountryCode") +
                " " +
                entity.citizenshipCountryCode}
            </span>
          )}
        </>
      ) : (
        <>
          <CorporationIcon />
          <span className="ml-10 w-[160px]">{entity.name}</span>

          {entity.creationDate && (
            <span className="ml-[150px] w-[200px]">
              {t("modal.entityDetails.entity.creationDate") + " " + entity.creationDate}
            </span>
          )}

          {entity.registrationCountryCode && (
            <span className="ml-[60px] w-[200px]">
              {t("modal.entityDetails.entity.registrationCountryCode") +
                " " +
                entity.registrationCountryCode}
            </span>
          )}
        </>
      )}
    </div>
  );
};
